export const SITE_TAKEOFF_V2_TOUR_STORAGE_KEY = 'siteTakeoffV2_tourSeen_v1';

export const SITE_TAKEOFF_V2_TOUR_STEPS = [
  {
    id: 'client-picker',
    target: '[data-tour="site-takeoff-client-picker"]',
    title: 'Select a Client',
    body: 'Use the client search to narrow jobsite results when needed.',
    placement: 'bottom',
  },
  {
    id: 'jobsite-picker',
    target: '[data-tour="site-takeoff-jobsite-picker"]',
    title: 'Select a Jobsite',
    body: 'Choose the property you want to map. The map will center on the selected site.',
    placement: 'bottom',
  },
  {
    id: 'map',
    target: '[data-tour="site-takeoff-map"]',
    title: 'Map Workspace',
    body: 'This is the main workspace for drawing, editing, and reviewing mapped property features.',
    placement: 'left',
  },
  {
    id: 'setup-status',
    target: '[data-tour="site-takeoff-setup-status"]',
    title: 'Check Setup Status',
    body: 'This badge tracks whether areas are mapped, the geofence is set, and property lines are verified.',
    placement: 'bottom',
  },
  {
    id: 'settings-button',
    target: '[data-tour="site-takeoff-settings-button"]',
    title: 'Open Property Settings',
    body: 'Use Property Settings to manage geofence, property lines, restricted areas, and production rates.',
    placement: 'left',
  },
  {
    id: 'geofence-section',
    target: '[data-tour="site-takeoff-geofence-section"]',
    title: 'Set the Geofence',
    body: 'Adjust the geofence radius and reposition the center if the property needs it.',
    placement: 'left',
  },
  {
    id: 'property-lines-section',
    target: '[data-tour="site-takeoff-property-lines-section"]',
    title: 'Verify Property Lines',
    body: 'Review county parcel data or draw a custom boundary when the property needs an override.',
    placement: 'left',
  },
  {
    id: 'takeoff-selector',
    target: '[data-tour="site-takeoff-selector"]',
    title: 'Manage Takeoffs',
    body: 'Create, rename, switch, or delete takeoffs for the active jobsite here.',
    placement: 'left',
  },
  {
    id: 'draw-area',
    target: '[data-tour="site-takeoff-draw-area"]',
    title: 'Draw Areas',
    body: 'Start mapping with a polygon, line, ellipse, or point marker depending on the feature.',
    placement: 'left',
  },
  {
    id: 'save-button',
    target: '[data-tour="site-takeoff-save-button"]',
    title: 'Save Your Work',
    body: 'Save becomes available once the takeoff has areas and unsaved changes.',
    placement: 'left',
  },
  {
    id: 'projects-upload',
    target: '[data-tour="site-takeoff-projects-upload"]',
    title: 'Add Plan Overlays',
    body: 'Projects mode lets you upload overlays and plan images for reference while mapping.',
    placement: 'left',
  },
];

export default SITE_TAKEOFF_V2_TOUR_STEPS;
